(function () {
    'use strict';

    angular
        .module('app')
        .factory('viewerService', viewerService);

    viewerService.$inject = ['$http', '$q', '$localStorage', 'hubFactory', 'loginService', '$interval', 'clientService', 'zcs', '$mdDialog', '$timeout'];

    function viewerService($http, $q, $localStorage, hubFactory, loginService, $interval, clientService, zcs, $mdDialog, $timeout) {

        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }

        //URL for the viewer wrapper service
        var defaultPort = window.location.protocol === "http:" ? "3922" : "3923";
        var port = $localStorage.viewerPort ? $localStorage.viewerPort : defaultPort;
        var id = $localStorage.viewerId ? $localStorage.viewerId : uuidv4();
        $localStorage.viewerId = id;
        var VIEWERURL = window.location.protocol + "//localhost:" + port;

        var service = {
            canPrint: canPrint,
            viewFiles: viewFiles,
            convertToPdfServer: convertToPdfServer,
            clearItemsCache: clearItemsCache
        };

        var USER_DATA = null;
        var httpRequest = function (type, url, data, timeout) {
            if (!timeout)
                timeout = 0;
            var deferred = $q.defer();
            $.ajax({
                type: type,
                url: url,
                data: data,
                timeout: 0,
                success: function (result) {
                    deferred.resolve(result);
                },
                error: function (request, status, error) {
                    deferred.reject(error);
                }
            });
            return deferred.promise;
        }
        service.processing = false;
        service.currentFile = "";
        service.currentFiles = [];

        return service;

        function needPrintParams(convertToPdf, records) {
            var fileList = [];
            angular.forEach(records, function(item) {
                fileList.push({ id: id, fileId: item.fileId, majRev: item.majRev, minRev: item.minRev });
            });
            var deferred = $q.defer();
            if (convertToPdf) {
                getPrintParameters(fileList).then(function(resp) {
                    deferred.resolve(resp.data);
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        function viewFiles(records, viewerOptions, convertToPdf, sourceGrid, printPdf) {
            var deferred = $q.defer();

            var mobile = (bowser.mobile || bowser.tablet) && (bowser.ios || bowser.android);

            if (mobile) {
                convertToPdf = true;
            }

            var wle = viewerOptions.viewerWhiteListExtensions;
            var allowedRecords = [];
            var disAllowedRecords = [];

            GetShowViewCommand(records).then(function(recs) {
                records = recs;
                if (wle) {
                    //put the extensions in an array and make them lowercase
                    var wleArr = wle.split(',');
                    var tmp = wleArr.join('~').toLowerCase();
                    var whiteListExt = tmp.split('~');
    
                    angular.forEach(records, function (item) {
                        var fileName = item.filename;
                        var fileExt = "." + fileName.split('.').pop().toLowerCase();
    
                        var allowed = false;
    
                        for (var i = 0; i < whiteListExt.length; i++) {
                            var wExt = whiteListExt[i];
    
                            if (fileExt === wExt) {
                                allowed = true;
                            }
                        }
    
                        if (item.allowed && allowed)
                            allowedRecords.push(item);
                        else
                            disAllowedRecords.push(item);
    
                    });
                }
                else {
                    allowedRecords = records;
                }
    
                if (allowedRecords.length == 0) {
                    service.processing = false;
                    deferred.resolve();
                }
    
                angular.forEach(records, function (file) {
                    var allowed = true;
    
                    angular.forEach(disAllowedRecords, function (item, key) {
                        if (item == file) {
                            allowed = false;
                        }
                    });
    
                    if (allowed) {
                        var status = printPdf ? "" : "Preparing for view";
                        service.currentFiles.push({ reason: status, name: file.filename, fileObj: file, error: false });
                    }
                    else {
                        if (file.error) {
                            service.currentFiles.push({ reason: file.error, name: file.filename, fileObj: file, error: true });
                        }
                        else {
                            service.currentFiles.push({ reason: loginService.resourceStrings["VIEWER_UNSUPPORTED_EXT"] + " " + file.filename.split(".").pop(), name: file.filename, fileObj: file, error: true });
                        }
                    }
                });

                needPrintParams(convertToPdf, allowedRecords).then(function(printparameters) {

                    showDialog(printPdf, printparameters).then(function (printParams) {
                        if (allowedRecords.length > 0) {
                            //check if we need print parameters
                            if (loginService.creator && viewerOptions["UseLocalViewer"] === "true" && !mobile) {
                            
                                clientService.checkACS().then(function () {
                                    viewFilesLocal(allowedRecords, viewerOptions, convertToPdf, sourceGrid, printPdf, printParams).then(function () {
                                        service.processing = false;
                                        deferred.resolve();
                
                                        var errors = false;            
                                        angular.forEach(service.currentFiles, function (item) {
                                            if (item.error) {
                                                errors = true;
                                            }
                                        });
    
                                        if (!errors) {
                                            $mdDialog.hide();
                                            service.currentFiles = [];
                                        }
                
                                    }, function (error) {
                                        service.processing = false;
                                        deferred.reject(error);
                                    });
                                });
                            }
                            else {
                                viewFilesRemote(allowedRecords, viewerOptions, convertToPdf, sourceGrid, printPdf, printParams).then(function () {
                                    service.processing = false;
                                    deferred.resolve();
            
                                    var errors = false;
            
                                    angular.forEach(service.currentFiles, function (item) {
                                        if (item.error) {
                                            errors = true;
                                        }
                                    });
            
                                    if (!errors) {
                                        $mdDialog.hide();
                                        service.currentFiles = [];
                                    }
            
            
                                }, function (error) {
                                    service.processing = false;
                                    deferred.reject(error);
                                });
                            }
                        }
                        else {
                            service.processing = false;
                            deferred.resolve();
                        } 
                    });
                });
            });
            return deferred.promise;
        }

        var stopInterval;
        function viewFilesRemote(records, viewerOptions, convertToPdf, sourceGrid, printPdf, printParams) {
            var deferred = $q.defer();

            var conversionUrl = viewerOptions["ViewerConversionUrl"];
            var viewerUrl = viewerOptions["ViewerUrl"];

            //call get printparameters

            prepareFilesRemoteViewer(records, viewerOptions, sourceGrid).then(function (filesToView) {
                var promiseArr = [];

                //check for cache
                checkForCache(filesToView).then(function(filesToView) {
                    //cache files
                    angular.forEach(filesToView, function (item) {

                        var gridRec = getStatusGridRec(item);

                        var path = item.data.fileId + '.' + item.data.majRev + '.' + item.data.minRev;

                        // if (item.error) {
                        //     gridRec.error = true;
                        //     gridRec.reason = "There was an error on the server";
                        // }
                        
                        if (!convertToPdf) {
                            gridRec.reason = loginService.resourceStrings["VIEWER_CACHING"];
                        }
                        else {
                            gridRec.reason = "Staging";
                            item.isCached = true;
                        }

                        var promise = cacheFile(item.data, path, conversionUrl, item.isCached);

                        promiseArr.push(promise);

                        promise.then(function (resp) {

                            if (resp.error) {
                                gridRec.reason = resp.message;
                                gridRec.error = true;
                                gridRec.log = true;
                            }
                            else {
                                if (!convertToPdf)
                                    gridRec.reason = loginService.resourceStrings["VIEWER_READY"];
                            }
                        });

                    });

                    
                    $q.all(promiseArr).then(function () {
                        //ensure no file errored
                        var goodFiles = [];
                        var pdfsToPrint = [];
                        for (var i = 0; i < filesToView.length; i++) {
                            var gridRec = getStatusGridRec(filesToView[i]);
                            if (!gridRec.error) {
                                goodFiles.push(filesToView[i]);
                            }
                        }

                        if (goodFiles.length > 0) {
                            if (!convertToPdf) {
                                createFileList(goodFiles, "web").then(function (id) {
                                    loginService.refreshToken().then(function (resp) {
                                        var token = resp.data.access_token;
                                        OpenViewer(token, id, viewerUrl);
                                        deferred.resolve();
                                    });
                                });
                            }
                            else {
                                var fileList = [];
                                var id = uuidv4();
                                opened = [];
                                angular.forEach(goodFiles, function (record) {
                                    var treeStyle = 16;

                                    if (loginService.informationSourceWip == true) {
                                        treeStyle = treeStyle | 4;
                                    }
                                    else {
                                        treeStyle = treeStyle | 2;
                                    }
                        
                                    if (sourceGrid === "dd") {
                                        treeStyle = treeStyle | 32;
                                    }
                                    var printParam = {};
                                    var fileId = record.data.fileId; 
                                    var majRev = record.data.majRev; 
                                    var minRev = record.data.minRev
                                    angular.forEach(printParams, function(param) {
                                        var paramFileId = param.baseFileId;
                                        var paramMajRev = param.baseMajorRev;
                                        var paramMinRev = param.baseMinorRev;

                                        if (fileId == paramFileId && majRev == paramMajRev && minRev == paramMinRev) {
                                            printParam = param;
                                        }
                                    });

                                    fileList.push({ id: id, tableNumber: record.data.tableNumber, fileId: fileId, majRev: majRev, minRev: minRev, treeStyle: treeStyle, parameters: printParam });
                                });

                                convertToPdfServer(fileList).then(function (result) {
                                    var failures = false;
                                    if (angular.isDefined(stopInterval)) {
                                        $interval.cancel(stopInterval);
                                        stopInterval = undefined;
                                    }
                                    console.log("CONVERT_TO_PDF_COMPLETED!");
                                    $timeout(function() {
                                        angular.forEach(result, function(item) {
                                            item.Key = item.Item.baseFileId + "." + item.Item.baseMajorRev + "." + item.Item.baseMinorRev;
                                            if (item.Success) {
                                                var gridRec = getStatusGridRec(item.Item);
                                                if (gridRec)
                                                    gridRec.reason = "Complete";

                                                    if (!printPdf) {
                                                        if (!wasOpened(item)) {
                                                            console.log("Opening File = ",  item.Item.fileName);
                                                            getPpfFile(item.Item.baseFileId, item.Item.baseMajorRev, item.Item.baseMinorRev, item.Item.fileName, printPdf);
                                                        }
                                                        else {
                                                            console.log("File already opened =", item.Item.fileName)
                                                        }
                                                    }
                                                    else {
                                                        pdfsToPrint.push(item);
                                                    }

                                                
                                            }
                                            else {
                                                failures = true;
                                                var gridRec = getStatusGridRec(item.Item);
                                                gridRec.error = true;
                                                gridRec.reason = item.ErrorMessage;                    
                                            }
    
                                        });

                                        if (printPdf && pdfsToPrint.length > 0) {
                                            console.log("get combined files");
                                            getCombinedPdfFileServer(pdfsToPrint).then(function() {
                                                deferred.resolve(result);
                                            }, function(error) {
                                                //error
                                                
                                                angular.forEach(pdfsToPrint, function(file) {
                                                    var rec = { fileId: file.Item.baseFileId, majRev: file.Item.baseMajorRev, minRev: file.Item.baseMinorRev };
                                                    var gridRec = getStatusGridRec(rec);
                                                    gridRec.reason = "There was an error obtaining the PDF file check server logs for more info.";
                                                    gridRec.error = true;
                                                });
                                            });
                                        }
                                        else {
                                            deferred.resolve(result);
                                        }          
                                    },500);
                                }, function (error) {

                                    //catastrophic error
                                    angular.forEach(service.currentFiles, function (item) {
                                        item.error = true;
                                        item.reason = error.data.Message;
                                    });
                                    deferred.reject(error);
                                });

                                //At the same time get status info
                                stopInterval = $interval(function () {
                                    getPDFConverterStatusSever(id).then(function (resp) {
                                        angular.forEach(resp.data, function (item) {
                                            var keys = item.Key.split(".");
                                            var rec = { fileId: keys[0], majRev: parseInt(keys[1]), minRev: parseInt(keys[2]) };
                                            var gridRec = getStatusGridRec(rec);
                                            if (gridRec) {
                                                switch (item.CurrentStatus) {
                                                    case 0:
                                                        gridRec.reason = "In queue";
                                                        break;
                                                    case 1:
                                                        gridRec.reason = loginService.resourceStrings["VIEWER_CONVERTING_TO_PDF"];
                                                        break;
                                                    case 2:
                                                        gridRec.reason = "Complete";
                                                        if (!wasOpened(item)) {
                                                            console.log("Opening File = ", item.Filename);
                                                            opened.push(item);
                                                            if (!printPdf) {
                                                                getPpfFile(rec.fileId, rec.majRev, rec.minRev, item.Filename);
                                                            }
                                                        }
                                                        break;
                                                    case 3:
                                                        gridRec.reason = item.Message;
                                                        gridRec.error = true;
                                                        break;
                                                    default:
                                                }
                                            }
                                        });
                                    });

                                }, 2000);               
                            }
                        }
                    });

                });
            }, function (error) {
                console.log(error);
                deferred.reject(error);
            });

            return deferred.promise;
        }

        function viewFilesLocal(records, viewerOptions, convertToPdf, sourceGrid, printPdf, printParams) {
            var deferred = $q.defer();
            prepareSchemaFileOps(records, sourceGrid).then(function (fileOps) {

                loginService.getLongTermKey().then(function (token) {

                    var promiseArr = [];
                    var filesToView = [];

                    angular.forEach(fileOps, function (item) {

                        var gridRec = {};

                        for (var i = 0; i < service.currentFiles.length; i++) {
                            var current = service.currentFiles[i].fileObj;

                            if (current.fileId === item.baseItemFileId && current.majRev === item.baseItemMajRev && current.minRev === item.baseItemMinRev) {
                                gridRec = service.currentFiles[i];
                            }
                        }

                        if (!convertToPdf)
                            gridRec.reason = "Caching File";
                        else 
                            gridRec.reason = "Staging File";

                        promiseArr.push(clientService.post('Viewer/PrepareForViewing',
                            {
                                serverURL: window.location.origin,
                                xRefReturnPacketModel: item,
                                serverRenderingExtensions: viewerOptions.viewerServerRenderingExtensions,
                                pdfConvert: convertToPdf,
                                //Bill 02/21/22 Added whitelist extensions
                                viewerWhiteListExtensions: viewerOptions.viewerWhiteListExtensions,

                                accessToken: token
                            }, true).then(function (viewItem) {
                                if (!convertToPdf)
                                    gridRec.reason = "Ready for Viewing";
                                
                                filesToView.push({
                                    baseFileId: viewItem.fileId,
                                    baseMinorRev: viewItem.minor,
                                    baseMajorRev: viewItem.major,
                                });
                            }, function (error) {
                                if (error.responseJSON) {
                                    gridRec.error = true;
                                    gridRec.local = true;
                                    gridRec.log = true;
        
                                    if (error.responseJSON.ExceptionMessage)
                                        gridRec.reason = error.responseJSON.ExceptionMessage;
                                    else
                                        gridRec.reason = error.responseJSON.Message;
                                }
                                deferred.resolve();
                            }));
                    });
                    
                    $q.all(promiseArr).then(function () {
                        var URL = window.location.protocol + "//" + window.location.host + '/Synergis.WebAPI';
                        if (filesToView.length > 0) {

                            if (!convertToPdf) {
                                createFileList(filesToView).then(function (id) {
                                    loginService.refreshToken().then(function (resp) {
                                        var token = resp.data.access_token;
                                        
                                        clientService.get('Viewer/OpenViewer?listId=' + id + '&authCode=' + token + '&webApiUrl=' + encodeURIComponent(URL) + '&isRdp=false').then(function () {
                                            deferred.resolve();
                                        });
                                    });
                                }, function (error) {
                                    deferred.reject(error);
                                });
                            }
                            else {
                                /*clientService.get('Viewer/ConvertOrPrint'*/
                                var fileList = [];
                                var id = uuidv4();
                                var pdfsToPrint = [];
                                angular.forEach(filesToView, function(item) {
                                    fileList.push({ id: id, fileId: item.baseFileId, majRev: item.baseMajorRev, minRev: item.baseMinorRev });
                                });
                                var data = { printParametters: printParams, viewerServerRenderingExtensions: viewerOptions.viewerServerRenderingExtensions };
                                    opened = [];
                                    
                                    clientService.post('Viewer/ConvertToPDF?id='+id + "&webApiUrl=" + encodeURIComponent(URL) + "&accessToken="+ token, data).then(function (resp) {
                                        console.log("CONVERT_TO_PDF_COMPLETE");

                                        if (angular.isDefined(stopInterval)) {
                                            $interval.cancel(stopInterval);
                                            stopInterval = undefined;
                                        }

                                        $timeout(function() {
                                            var hasError = false;
                                            

                                            angular.forEach(resp, function (item) {
                                                var rec = { fileId: item.Item.baseFileId, majRev: item.Item.baseMajorRev, minRev: item.Item.baseMinorRev };
                                                item.Key = item.Item.baseFileId + "." + item.Item.baseMajorRev + "." + item.Item.baseMinorRev;
                                                var gridRec = getStatusGridRec(rec);
                                                if (!item.Success) {
                                                    if (gridRec) {
                                                        gridRec.reason = item.ErrorMessage;
                                                        gridRec.error = true;
                                                    }
                                                    hasError = true;
                                                }
                                                else {
                                                    if (gridRec)
                                                        gridRec.reason = "PDF Conversion Complete";
                                                    if (!wasOpened(item)) {
                                                        opened.push(item);
                                                        console.log("Opening File = ", item.Item.fileName);
                                                        if (!printPdf) {
                                                            clientService.getPdfFile(item).then(function (resp) {                                                                   
                                                                var blob = new Blob([resp.data], { type: "application/pdf" });
                                                                var data = window.URL.createObjectURL(blob);
                                                                window.open(data);
                                                            });
                                                        }
                                                        else {
                                                            //When printing we just add the file to a list to combine later
                                                            console.log("adding file to pdfsToPrint");
                                                            pdfsToPrint.push(item);   
                                                        }
                                                        createAuditTrailPDF(item.Item.baseFileId, item.Item.baseMajorRev, item.Item.baseMinorRev).then(function() {
                                                            console.log("CreateAuditTrailPDF Done!");
                                                        }); 
                                                    }
                                                    else {
                                                        console.log("File already opened = ", item.Item.fileName);
                                                    }
    
                                                }
                                            });

                                            if (printPdf & pdfsToPrint.length > 0) {
                                                //Get the combined PDF
                                                clientService.getCombinedPdfFile(pdfsToPrint).then(function(resp) {
        
                                                    var blob = new Blob([resp.data], { type: "application/pdf" });
                                                    var data = window.URL.createObjectURL(blob);

                                                    //send the job to the printer
                                                    printJS({ printable: data, onPrintDialogClose: function() {
                                                        console.log("Print Dialog closed");
                                                    }});
                                                });
                                            }

                                            
                                            deferred.resolve();
                                        }, 2000);
                                    });

                                    stopInterval = $interval(function () {
                                        getPDFConverterStatusAcs(id).then(function (resp) {
                                            angular.forEach(resp, function (item) {
                                                var keys = item.Key.split(".");
                                                var rec = { fileId: keys[0], majRev: parseInt(keys[1]), minRev: parseInt(keys[2]) };
                                                var gridRec = getStatusGridRec(rec);
                                                console.log("Status", item);
                                                if (gridRec) {
                                                    switch (item.CurrentStatus) {
                                                        case 0:
                                                            gridRec.reason = "In queue";
                                                            break;
                                                        case 1:
                                                            gridRec.reason = loginService.resourceStrings["VIEWER_CONVERTING_TO_PDF"];
                                                            break;
                                                        case 2:
                                                            gridRec.reason = "PDF Conversion Complete";                            
                                                            if (!wasOpened(item)) {
                                                                opened.push(item);
                                                                console.log("Opening file = ", item.Filename);
                                                                //if it's a print job, instead of opening it, print it
                                                                if (!printPdf) {
                                                                    clientService.getPdfFile(item).then(function (resp) {                                                                   
                                                                        var blob = new Blob([resp.data], { type: "application/pdf" });
                                                                        var data = window.URL.createObjectURL(blob);
                                                                        window.open(data);
                                                                        
                                                                    });
                                                                }
                                                                else {
                                                                    //Add it to the list of PDFs to print
                                                                    pdfsToPrint.push(item);
                                                                }  
                                                                createAuditTrailPDF(rec.fileId, rec.majRev, rec.minRev);
                                                            }
                                                            break;
                                                        case 3:
                                                            gridRec.reason = item.Message;
                                                            gridRec.error = true;
                                                            break;
                                                        default:
                                                    }
                                                }
                                            });
                                        });
        
                                    }, 2000);
                            }
                        }
                        else {
                            deferred.resolve();
                        }
                    }, function (error) {
                        console.log("error");
                        deferred.reject(error);
                    });

                }, function (error) {
                    deferred.reject(error);
                });


            }, function (error) {
                deferred.reject(error);
                console.log("error");
            });
            return deferred.promise;
        }

        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        }

        function canPrint(fileId) {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/View/PrintAllowed/' + fileId).then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function clearItemsCache(records) {
            var deferred = $q.defer();
            var promise = $q.all([]);
            service.processing = true;
            angular.forEach(records.list, function (item, index) {
                promise.then(function() {
                    var d = $q.defer();
                    service.currentFile = item.fileName;
                    $http.get('../Synergis.WebApi/api/view/ClearItemsCache/' + item.fileId + '/' + item.majRev + '/' + item.minRev).then(function(response) {

                        if (index == records.list.length - 1) {
                            service.processing = false;
                            deferred.resolve();
                        }
                        d.resolve();
                    }, function() {
                        if (index == records.list.length - 1) {
                            service.processing = false;
                            deferred.resolve();
                        }
                        d.resolve();
                    });
                    return d.promise;
                });    
            });
            return deferred.promise;
        }

        function checkPrintPdf(printPdf, creator) {
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        }


        var dialogDeferred;

        function showDialog(printPdf, printParams) {
            
            dialogDeferred = $q.defer();
            
            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: "app/viewpdf/templates/viewerStatus.html",
                controller: dialogController,
                fullscreen: false,
                locals: {
                    printPdf: printPdf,
                    StartPrinting: StartPrinting,
                    printParams: printParams
                },
                controllerAs: 'ctrl'
            });

            if (!printPdf) {
                dialogDeferred.resolve(printParams);
            }

            return dialogDeferred.promise;
        }

        function StartPrinting(printParams) {
            dialogDeferred.resolve(printParams);
        }

        function GetShowViewCommand(records) {
            var deferred = $q.defer();
            var promise = $q.all([]);
            angular.forEach(records, function(item, index) {
                promise = promise.then(function() {
                    var d = $q.defer();
                    $http.get("../Synergis.WebApi/api/SelectionCommand/IsAllowedToView/" + item.detailedInfo.libId + "/" + item.fileId + "/" + item.majRev + "/" + item.minRev).then(function(response) {
                        
                        var data = response.data;
                        if (data.errorMessage != "") {
                            item.allowed = false;
                            item.error = data.errorMessage;
                        }
                        else {
                            item.allowed = true;
                        }
                        d.resolve(item);

                        if (index === records.length - 1) {
                            deferred.resolve(records);
                        }
                    });
                    return d.promise;
                });
            });
            return deferred.promise;
        }

        dialogController.$inject = ['viewerService', 'StartPrinting', 'printPdf', 'printParams', 'ngModel', 'loginService'];

        function dialogController(viewerService, StartPrinting, printPdf, printParams, loginService) {
            this.title = "Viewer Status";
            this.viewerService = viewerService;
            this.printPdf = printPdf;
            this.layouts = {};
            this.layout = { someprop: "0" };
            this.processing = false;
            this.gridOptions = {
                data: viewerService.currentFiles,
                multiSelect: false,
                modifierKeysToMultiSelect: false,
                enableFullRowSelection: true,
                enableRowHeaderSelection: false,
                useExternalSorting: true,
                enableColumnMenus: false,
                enableColumnResizing: true,
                columnDefs: [

                    { name: 'Name', field: 'name', width: '40%', minWidth: '100' },
                    { name: 'Status', field: 'reason', width: '40%', minWidth: '300', cellTemplate: "<md-tooltip style='font-size: 15px' md-direction='top'>{{COL_FIELD}}</md-tooltip><div ng-if='!row.entity.error' class='ui-grid-cell-contents' style='color: green'>{{COL_FIELD}}</div><div ng-if='row.entity.error' class='ui-grid-cell-contents' style='color: red'>{{COL_FIELD}}</div>" },
                    { name: '', field: 'name', cellTemplate: "<div ng-if='row.entity.log' class='ui-grid-cell-contents'><button style='padding: 2px 10px !important; min-width:0 !important' class='button primary-button' ng-click='grid.appScope.ctrl.viewLog(row.entity.fileObj, row.entity.local)'>" + loginService.resourceStrings["VIEWER_VIEW_LOG"] + "</button></div>" },
                ],
                onRegisterApi: null
            }


            if (printPdf) {
                this.title = loginService.resourceStrings['PRINT_TO'];
                if (printParams) {
                    for (var i= 0;i<printParams.length;i++) {
                        this.layouts[printParams[i].baseFileId + '.' + printParams[i].baseMajorRev + '.' + printParams[i].baseMinorRev] = printParams[i].viewItemParameters.printOption.layout.toString();
                    }
                }
                var column = { name: 'Orientation', field: 'ss', minWidth: '120', cellTemplate: "<div class='ui-grid-cell-contents'><select style='font-size=16px; border: none' ng-disabled='grid.appScope.ctrl.processing' ng-model='grid.appScope.ctrl.layouts[row.entity.fileObj.fileId + \".\" + row.entity.fileObj.majRev + \".\" + row.entity.fileObj.minRev]' ng-change='grid.appScope.ctrl.optionChanged(row.entity.fileObj.fileId + \".\" + row.entity.fileObj.majRev + \".\" + row.entity.fileObj.minRev)'><option value='0'>Auto</option><option value='1'>Landscape</option><option value='2'>Portrait</option></select></div>" };

                this.gridOptions.columnDefs.splice(1, 0, column);
            }

            this.closeDialog = function () {
                viewerService.currentFiles = [];
                $mdDialog.hide();
            }
            
            this.startPrinting = function() {
                this.processing = true;
                StartPrinting(printParams);
            }
            
            this.optionChanged = function(fileId) {
                var layouts = this.layouts;
                angular.forEach(printParams, function(param) {
                    var combined = param.baseFileId + '.' + param.baseMajorRev + '.' + param.baseMinorRev;
                    if (combined == fileId) {
                        param.viewItemParameters.printOption.layout = parseInt(layouts[fileId]);
                    }
                });
            }

            this.viewLog = function (record, local) {
                var deferred = $q.defer();
                if (!local) {
                    var url = "../Synergis.WebApi/api/View/GetViewLog/" + record.tableNumber + "/" + record.fileId + '/' + record.majRev + '/' + record.minRev;
                    $http({
                        url: url,
                        method: 'GET',
    
                    }).then(function (resp) {
                        deferred.resolve();
    
                        $mdDialog.hide();
    
                        $timeout(function () {
                            showLogDialog(resp.data);
                        }, 200);
                    });
                }
                else {
                    clientService.getViewerLogFile(record.fileId, record.majRev, record.minRev).then(function (resp) {
                        deferred.resolve();
    
                        $mdDialog.hide();
    
                        $timeout(function () {
                            showLogDialog(resp.data);
                        }, 200);
                    });
                }


                return deferred.promise;
            }

        }

        function showLogDialog(log) {
            $mdDialog.hide();

            $mdDialog.show({
                parent: angular.element(document.body),
                templateUrl: "app/viewpdf/templates/viewerLog.html",
                controller: logDialogController,
                fullscreen: false,
                locals: {
                },
                controllerAs: 'ctrl'
            });


            function logDialogController() {
                this.data = log;

                this.closeDialog = function () {
                    $mdDialog.hide();
                    $timeout(function () {
                        showDialog();
                    }, 100);
                }
            }

        }

        function convertToPdfServer(data) {
            var deferred = $q.defer();

            
            //service.processing = true;
            //service.currentFile = "Converting to PDF";
            $http({
                url: "../Synergis.WebApi/api/View/ConvertToPDF",
                method: 'POST',
/*                responseType: "blob",*/
                headers: {
                    'Content-Type': 'application/json'                    
                },
                data: JSON.stringify(data)
            }).then(function (resp) {
/*                var blob = new Blob([resp.data], { type: "application/pdf" });*/
/*                var data = window.URL.createObjectURL(blob);*/
/*                window.open(data);*/
                service.processing = false;
                deferred.resolve(resp.data);
            }, function (error, jjj) {
                service.processing = false;
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function getPpfFile(fileId, majRev, minRev) {
            $http({
                url: "../Synergis.WebApi/api/view/GetPdfFile/" + fileId + "/" + majRev + "/" + minRev,
                method: "GET",
                responseType: "blob"
            }).then(function (resp) {

                var blob = new Blob([resp.data], { type: "application/pdf" });
                var data = window.URL.createObjectURL(blob);
                window.open(data, "_blank");
                //alternative instead of using blob, this will download the file instead of opening it in a new tab.
                // var fileLink = document.createElement('a');
                // fileLink.href = data;
                // fileLink.download = fileName;
                // fileLink.click();
                
            });
        };

        function getCombinedPdfFileServer(items) {
            var deferred = $q.defer();
            $http({
                url: "../Synergis.WebApi/api/view/CombinePdfFiles",
                method: "POST",
                responseType: "blob",
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(items)
            }).then(function (resp) {

                var blob = new Blob([resp.data], { type: "application/pdf" });
                var data = window.URL.createObjectURL(blob);

                printJS({printable: data, type: 'pdf' });    
                deferred.resolve();            
            }, function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function createAuditTrail(fileId, majRev, minRev) {
            var URL = window.location.protocol + "//" + window.location.host + '/Synergis.WebAPI/api/View/AuditViewFile/'+ fileId + "/" + majRev + "/" + minRev;
            return $http({
                url: URL,
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                } 
            });
        }

        function createAuditTrailPDF(fileId, majRev, minRev) {
            var URL = window.location.protocol + "//" + window.location.host + '/Synergis.WebAPI/api/View/AuditCreatePDF/' + fileId + "/" + majRev + "/" + minRev;
            return $http({
                url: URL,
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            });
        }


        function getPrintParameters(items) {
            return $http({
                url: "../Synergis.WebApi/api/View/PrintParameters",
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(items)
            });
        }

        function prepareSchemaFileOps(records, sourceGrid) {
            var deferred = $q.defer();
            var promise = $q.all([]);
            var filesToView = [];

            angular.forEach(records, function (item, index) {
                service.currentFile = item.filename;
                promise = promise.then(function () {
                    var d = $q.defer();
                    getSchemaFileOperations(item, sourceGrid).then(function (itemOpPacket) {
                        filesToView.push(itemOpPacket);
                        if (index == records.length - 1) {
                            d.resolve();
                            deferred.resolve(filesToView);
                        }
                        else {
                            d.resolve();
                        }
                    }, function (error) {
                        d.reject(error);
                        console.log(error);
                        deferred.reject(error);
                    });
                });

            });

            return deferred.promise;
        }

        var opened = [];

        function wasOpened(it) {
            for (var i = 0; i < opened.length;i++) {
                if (opened[i].Key === it.Key) {
                    return true;
                }
            }
            return false;
        }

        function getStatusGridRec(item) {
            var gridRec = {};
            for (var i = 0; i < service.currentFiles.length; i++) {
                var current = service.currentFiles[i].fileObj;

                if (item.data) {
                    if (current.fileId === item.data.fileId && current.majRev === item.data.majRev && current.minRev === item.data.minRev) {
                        gridRec = service.currentFiles[i];
                        return gridRec;
                    }
                }
                else {
                    if (current.fileId === item.fileId && current.majRev === item.majRev && current.minRev === item.minRev) {
                        gridRec = service.currentFiles[i];
                        return gridRec;
                    }
                    else if (current.fileId === item.baseFileId && current.majRev === item.baseMajorRev && current.minRev === item.baseMinorRev) {
                        gridRec = service.currentFiles[i];
                        return gridRec;
                    }
                    else if (current.fileId === item.baseItemFileId && current.majRev === item.baseItemMajRev && current.minRev === item.baseItemMinRev) {
                        gridRec = service.currentFiles[i];
                        return gridRec;
                    }
                }


            }
        }

        function checkForCache(filesToView) {
            var deferred = $q.defer();
            var promise = $q.all([]);

            angular.forEach(filesToView, function(item, idx) {
                promise = promise.then(function() {
                    console.log("Checking file " + item.fileName + " for cache");
                    var d = $q.defer();
                    $http.get('../Synergis.WebApi/api/View/isFileCached?fileId=' + item.baseFileId + "&majRev=" + item.baseMajorRev + "&minRev=" + item.baseMinorRev).then(function(resp) {
                        item.isCached = resp.data;
                        console.log("DONE! Checking file " + item.fileName + " for cache");
                        //last file?
                        if (idx === filesToView.length - 1) {
                            deferred.resolve(filesToView);
                        }
                        d.resolve()
                    }, function (err) {
                        item.error = true;
                        if (idx === filesToView.length - 1) {
                            deferred.resolve(filesToView);
                        }
                        d.resolve();
                    });
                    return d.promise;
                });
            });

            return deferred.promise;
        }

        function getPDFConverterStatusSever(id) {
            return $http.get('../Synergis.WebApi/api/View/GetConvertPdfStatus/' + id);
        }

        function getPDFConverterStatusAcs(id) {
            return clientService.get('Viewer/GetConvertPdfStatus?id=' + id);
        }

        function prepareFilesRemoteViewer(records, viewerOptions, sourceGrid) {
            var deferred = $q.defer();
            var promise = $q.all([]);

            var treeStyle = 16;

            if (loginService.informationSourceWip == true) {
                treeStyle = treeStyle | 4;
            }
            else {
                treeStyle = treeStyle | 2;
            }

            if (sourceGrid === "dd") {
                treeStyle = treeStyle | 32;
            }


            if (records.length == 0) {
                deferred.resolve();
            }
            var filesToView = [];
            angular.forEach(records, function (item, index) {
                var gridRec = {};
                for (var i = 0; i < service.currentFiles.length; i++) {
                    var current = service.currentFiles[i].fileObj;

                    if (current.fileId === item.fileId && current.majRev === item.majRev && current.minRev === item.minRev) {
                        gridRec = service.currentFiles[i];
                    }
                }
                service.currentFile = item.filename;
                promise = promise.then(function () {
                    var d = $q.defer();
                    service.currentFile = item.filename;

                    console.log("PrepareFileForViewing " + item.filename);

                    //Prepare file for viewing
                    // gridRec.reason = "Preparing file for viewing";
                    prepareFileForViewing(item, treeStyle).then(function (result) {
                        //check if file is cached
                        var path = item.fileId + '.' + item.majRev + '.' + item.minRev;
                        var forceCache = result.forceCache;
                        //set URLs for remote viewing
                        var conversionUrl = viewerOptions["ViewerConversionUrl"];
                        var viewerUrl = viewerOptions["ViewerUrl"];

                        console.log("DONE! PrepareFileForViewing " + item.filename);

                        //if the file is local file cannot be addded and we should show a message
                        if (result.bFileIsWorkstationLocal) {
                            gridRec.reason = "File " + item.filename + " is local and cannot be viewed";
                            d.resolve();
                        }
                        else {


                            filesToView.push({
                                baseFileId: item.fileId,
                                baseMinorRev: item.minRev,
                                baseMajorRev: item.majRev,
                                forceCache: forceCache,
                                data: item
                            });

                            //last file ?
                            if (index == records.length - 1) {
                                deferred.resolve(filesToView);
                            }
                            d.resolve();

                        }
                    }, function (error) {

                        gridRec.error = true;

                        if (loginService.resourceStrings[error.data.Message]) {
                            gridRec.reason = loginService.resourceStrings[error.data.Message];
                        }
                        else {
                            gridRec.reason = "Error: " + error.data.Message;
                        }


                        if (index == records.length - 1) {
                            deferred.resolve(filesToView);
                        }

                        d.resolve();
                    });
                    return d.promise;
                }, function (error) {
                    if (error.data) {
                        if (error.data.Message) {
                            error.data.Message = error.data.Message + " File: " + item.filename;
                        }
                    }
                    deferred.reject(error);
                });
            });
            return deferred.promise;
        }

        function prepareFileForViewing(record, treeStyle) {
            var deferred = $q.defer();
            //Prepare files for viewing
            $http.get('../Synergis.WebApi/api/View/PrepareForViewing/' + record.tableNumber + '/' + record.fileId + '/' + record.majRev + '/' + record.minRev + "/" + treeStyle).then(function (response) {
                var file = response.data[record.fileId + '.' + record.majRev + '.' + record.minRev];
                if (file.bFileIsWorkstationLocal) {
                    clientService.get('LocalVirtualLibraryPath', null, false).then(function (path) {

                        //Bill 08-31-22 Use GetTreeVirtualizedEX, pass (RT_VIEW (16d) OR RT_WIP (1)) = 17 to prevent manual chldren downloads
                        //$http.put("../Synergis.WebApi/api/document/GetTreeVirtualized/" + record.tableNumber + '/' + record.fileId + '/' + record.majRev + '/' + record.minRev + '/' + '18/' + "1", path).then(function (treeResp) {
                        $http.put("../Synergis.WebApi/api/document/GetTreeVirtualizedEx/" + record.tableNumber + '/' + record.fileId + '/' + record.majRev + '/' + record.minRev + '/' + '17/' + "1", path).then(function (treeResp) {


                            //call acs to prepare for viewing 
                            clientService.post('Viewer/PrepareForView', treeResp.data).then(function (result) {
                                deferred.resolve(file);
                            });

                        }, function (error) {
                                deferred.reject(error);
                        });
                    }, function (error) {
                            deferred.reject(error);
                    });
                }
                else {
                    deferred.resolve(file);
                }

            }, function (error) {
                    deferred.reject(error);
            });
            return deferred.promise;
        }

        function getSchemaFileOperations(item, sourceGrid) {
            var deferred = $q.defer();

            var treeStyle = 16; //RT_VIEW

            if (loginService.informationSourceWip == true) {
                treeStyle = treeStyle | 4; //RT_WIP
            }
            else {
                treeStyle = treeStyle | 2; //RT_APPROVED
            }

            if (sourceGrid === "dd") {
                treeStyle = treeStyle | 32; //RT_UNPROMOTED (chosen from Doc Dashboard tab)
            }

            zcs.GetLocalVirtualLibraryPath(true).then(function (data) {
                var localVirtualLibraryPath = data;

                //Bill 08-31-22 Use GetTreeVirtualizedEX
//                $http.put("../Synergis.WebApi/api/Document/GetTreeVirtualized/1/" + item.fileId + '/' + item.majRev + '/' + item.minRev + '/' + treeStyle + '/1', JSON.stringify(localVirtualLibraryPath)).then(function (result) {
//                    deferred.resolve(result.data);
                    $http.put("../Synergis.WebApi/api/Document/GetTreeVirtualizedEx/1/" + item.fileId + '/' + item.majRev + '/' + item.minRev + '/' + treeStyle + '/1', JSON.stringify(localVirtualLibraryPath)).then(function (result) {
                        deferred.resolve(result.data);

                }, function (error) {
                    deferred.reject(error);
                });
            });

            return deferred.promise;
        }

        function checkFileIsCached(record, url, deleteIfForce) {
            var deferred = $q.defer();
            var conversionUrl = url + "/api/StreamFile/adeptfileid";
            var requestData = {
                "baseFileId": record.fileId,
                "baseMajorRev": record.majRev,
                "baseMinorRev": record.minRev
            };
            $http.post(conversionUrl, JSON.stringify(requestData), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                if (response.data == "") {
                    deferred.resolve(false);
                }
                else {
                    if (deleteIfForce) {
                        deleteFileCache(url, response.data.id).then(function () {
                            deferred.resolve(false);
                        });
                    }
                    else {
                        deferred.resolve(true);
                    }
                }
            }, function (err) {
                    deferred.reject(err);
            });
            return deferred.promise;
        }

        function deleteFileCache(url, id) {
            var deleteUrl = url + "/api/StreamFile/"+id;
            return $http.delete(deleteUrl);
        }


        function createFileList(files, client) {
            var deferred = $q.defer();
            var url = "../Synergis.WebApi/api/View/CreateViewList";
            if (client == "web")
                url = "../Synergis.WebApi/api/View/CreateViewList?client='web'";

            var docRecs = [];
            angular.forEach(files, function (file) {
                docRecs.push({
                    docId: file.baseFileId,
                    majRev: file.baseMajorRev,
                    minRev: file.baseMinorRev
                });
            });

            $http.post(url, JSON.stringify(docRecs), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (resp) {
                deferred.resolve(resp.data);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

        function cacheFile(record, path, url, isCached) {

            angular.forEach(service.currentFiles, function (item) {

            });

            console.log("Caching file: " + record.filename);
            var deferred = $q.defer();
            var url = "../Synergis.WebApi/api/View/CacheFile";
            var requestData = {
                "FileName": record.filename,
                "FileId": record.fileId,
                "MajorRev": record.majRev,
                "MinorRev": record.minRev,
                "OriginalFilePath": path,
                "ForceCache": record.forceCache
            };

            if (!isCached) {
                $http.post(url, JSON.stringify(requestData), {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function (response) {
                    console.log("Caching complete: " + record.filename);
                    record.didCache = true;
                    deferred.resolve(record);
                }, function (error) {
                    console.log(error);
                    deferred.resolve({ error: true, message: error.data.Message });
                });
            }
            else {
                deferred.resolve(record);
            }


            return deferred.promise;
        }


        function OpenViewer(AUTHCODE, VIEWID, url) {
            //var token = "QFkySGDzv-SBZv_AzqHfhHRJmNzVvK4Xo6AO6N5zSpOX1UlcjnPrfNYF57AZ6BLw2P9VOq-ZUnsfI-PsQj8Ap8aCBul2zqBWMiA9RrihxfL9Wqu8M2tYEcrn2jefOp0euleI4mFeW2ea17tSjy0O17zb62H1HEQHySF0m-uU7Lt2BPI0B9fha0AQOjnJlNGmpXEjXUEQlwfKcUiz3DxDuTxnOuT3b4lqV_fHyYgbNjxLPPtb18O3qPCXP8kU6GsoyRgE5Z45-0unnKvxPOhLwlFQnvK6Ik-WOtYDN0gzRSdwmaDBQCEe-fBdwABXpUnjH2p8lWp022p_czyrXwq5ACDzke72vcloDQNUgcm5NXVojNiQFNMtaWJTJfGcCAEJglDvAadem8IkZGtkuGHdzR4Qf7dxcuQ2NJTx1KHF-nppRQUuXheQZlyiB05R0Whhuqy0X0LBYoCVyztn2VFITYc9H7-lngeZJxcQ6OcU3t6IRAAlzAB8DGfmFTGuiJ5H9tfD4KCJUnxURgFfN93OCSXf1SnnB8wsr1Nt3qzV8HhxC8vK5HC_969_6khcd6nx8Fg-WJmFio-9dM2-lNN5DvWjlyfiRJ4LNmjbR1gpTxFgHRYvCUPClN0FrXmdm5TigeV7-2GC8wdYyqCClpf8egOlmUouoj-JtMyoP-w5ZhnFbtPYZFuHYNwXTdIbBO2iWF0X7oMn4KSqJabs1n3mXiQdgJf5G_JMnpnOn7lw0cNPcvzk0EjGiudFOEoKfdjxlsTE598OOxO4ul9203K4HYvCDw-PX4criBhW6C9glr9gzqANfG1Y0X2_Z58nFFhx";
            var URL = window.location.protocol + "//" + window.location.host + '/Synergis.WebApi';
            var viewerUrl = url + "/main?AUTHCODE=" + AUTHCODE + "&VIEWID=" + VIEWID + "&URL=" + encodeURIComponent(URL);
            window.open(viewerUrl);
        }

        function uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        }

    }
})();

